const getBaseUrl = (url: string): string => {
  let parsedUrl;
  try {
    parsedUrl = new URL(url);
  } catch (_e) {
    return url;
  }
  return `${parsedUrl.protocol}//${parsedUrl.host}`;
};

export default getBaseUrl;
